import { WebGameFormikModel } from '../components/game-form-container/models/web-game-formik.model';
import { WebGameResponseModel } from '../models/web-game-response.model';

export const webGameResponseModelToFormik = (
  data: WebGameResponseModel
): WebGameFormikModel => ({
  title: data.title || '',
  size: data.size || '',
  orientation: data.orientation || '',
  zip: data.zip.id,
  thumbnail: data.thumbnail.id,
  genre: data.genre,
});
